import React from 'react';
import wrapSvgPath from './wrapSvgPath';

const homeIconPath = (
  <path id="home" fill="#323232" d="M14.56.21a.849.849 0 0 0-1.12 0L0 10.663l1.12 1.493L2.8 10.85v11.573a1.872 1.872 0 0 0 1.867 1.867h18.666a1.872 1.872 0 0 0 1.867-1.867V10.85l1.68 1.307L28 10.663zm1.307 22.213h-3.734v-7.466h3.733zm1.867 0v-7.466a1.872 1.872 0 0 0-1.867-1.867h-3.734a1.872 1.872 0 0 0-1.867 1.867v7.467h-5.6V9.45L14 2.17l9.333 7.28v12.973z" />
);

export default wrapSvgPath(homeIconPath, '0 0 28 24');
